import { Action, State } from "./types";

// Helper to safely get from localStorage
const getStoredState = (key: string): unknown => {
  try {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

// Helper to safely save to localStorage
const saveToStorage = (key: string, value: unknown): void => {
  try {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.removeItem(key);
    }
  } catch (error) {
    console.error(`Failed to save ${key} to localStorage:`, error);
  }
};

// Load persisted state from localStorage
const initialState: State = {
  login: getStoredState("redux_login") as State["login"],
  forgotPassword: null,
  search: null,
  result: getStoredState("redux_result") as State["result"],
  select: getStoredState("redux_select") as State["select"],
  userHistory: null,
  subHistory: null,
  giftCard: null,
  enterCode: null,
  advanceResult: getStoredState("redux_advanceResult") as State["advanceResult"],
  rsAdminResult: getStoredState("redux_rsAdminResult") as State["rsAdminResult"],
};

// eslint-disable-next-line default-param-last
export const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case "LOGIN":
      saveToStorage("redux_login", action.payload);
      return { ...state, login: action.payload };
    case "FORGOT_PASSWORD":
      return { ...state, forgotPassword: action.payload };
    case "ENTER_CODE":
      return { ...state, enterCode: action.payload };
    case "SEARCH":
      return { ...state, search: action.payload };
    case "RESULT":
      saveToStorage("redux_result", action.payload);
      return { ...state, result: action.payload };
    case "SELECT":
      saveToStorage("redux_select", action.payload);
      return { ...state, select: action.payload };
    case "USER_HISTORY":
        return { ...state, userHistory: action.payload };
    case "GIFT_CARD":
    return { ...state, giftCard: action.payload };
    case "SUB_HISTORY":
      return { ...state, subHistory: action.payload };
    case "ADVANCE_RESULT":
      saveToStorage("redux_advanceResult", action.payload);
      return { ...state, advanceResult: action.payload };
    case "RS_ADMIN_RESULT":
      saveToStorage("redux_rsAdminResult", action.payload);
      return { ...state, rsAdminResult: action.payload };
    default:
      return state;
  }
};
